<!-- Two palettes a row at most (three thirds and their gaps overflow), one once two do not fit. -->
<div class="flex flex-wrap gap-x-8 gap-y-12 max-w-3xl *:grow *:basis-1/3 *:min-w-fit">
  @for (color of colors(); track color.name) {
    <div class="flex flex-col gap-2">
      <h2 class="text-lg font-semibold">{{ color.name }}</h2>
      <div class="grid w-80 grid-cols-4 grid-rows-3 gap-2">
        @for (shade of color.shades; track shade.shade; let index = $index) {
          <div
            [class]="index === 4 ? 'row-start-2	row-end-4 col-start-1 col-end-5' : 'h-9'"
            [flxColourSwatch]="shade.hex"
            class="flex items-end rounded-lg p-1"
          >
            <div class="px-1 text-gray-500 text-2xs bg-white rounded-md">
              {{ shade.shade }}
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
